export default __webpack_public_path__ + "static/media/handAndWineCloseup-min.4c279c18.jpg";